import { get } from "helpers/api_helper";
import {
  normalizeAdminListFilters,
  normalizeAdminListOptions,
} from "helpers/adminListQueryPolicy"

const PRESERVED_EMPTY_FILTER_KEYS = ["timeframe"]

const parseQueryPart = value => {
  if (!value) return {}
  if (typeof value === "string") return JSON.parse(value)
  return { ...value }
}

export const createBookingsListUrl = (filters, options) => {
  const normalizedFilters = normalizeAdminListFilters(parseQueryPart(filters), {
    preserveEmptyKeys: PRESERVED_EMPTY_FILTER_KEYS,
  })
  const normalizedOptions = normalizeAdminListOptions(parseQueryPart(options))
  const filterParams = new URLSearchParams({
    ...normalizedFilters,
    ...normalizedOptions,
  }).toString()

  return `/bookings?${filterParams}`
}

export const getBookings = (filters, options) => get(createBookingsListUrl(filters, options))
export const getBookingDetails = id => get(`/bookings/${id}`)
